var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-col',[_c('div',{staticClass:"provisioning_btn_container"},[_c('a-button',{staticClass:"green_bg step_btn",attrs:{"block":"","size":"large","disabled":_vm.isLoading},on:{"click":_vm.handleInputSubmit}},[_vm._v("開通裝置")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }